import type { ApiId } from '@/types'
import type { FeedbackMessage } from '@/common/apis/feedback'

/** 自己发出的消息 id 是否已被对方读游标覆盖 */
export function isFeedbackMessageReadByPeer(
  msg: FeedbackMessage,
  selfType: 'USER' | 'STAFF',
  peerLastReadMessageId?: ApiId | null
) {
  if (msg.senderType !== selfType) return false
  if (peerLastReadMessageId == null || peerLastReadMessageId === '') return false
  try {
    return BigInt(String(msg.id)) <= BigInt(String(peerLastReadMessageId))
  } catch {
    return Number(msg.id) <= Number(peerLastReadMessageId)
  }
}
